<template>
<div>
  <div class="vx-row mb-4">
    <div class="vx-col md:w-1/2 w-full">
      <h2>{{ $t('banner.GenBannerTitle') }}</h2>
    </div>
    <div class="vx-col md:w-1/2 w-full">
        <div class="text-right" >
          <vs-button @click="setpopupNewBanner(true)" color="primary" type="border">{{ $t('banner.NewBanner') }}</vs-button>
          <vs-popup :title="$t('banner.NewBanner')" class="popup-w-900" :active.sync="popupNewBanner">
            <new-banner :isGeneric="isGeneric" ref="newGenBannerModal"></new-banner>
          </vs-popup>
        </div>
    </div>
  </div>
  <div class="vx-row">
    <div class="vx-col w-full">
      <table-data-grid :data="itemsDataGrid" :dataColumns="dataColumns" link="banner">
        <template v-slot:actions="slotProps" >
          <div class="dropdown-button-container">
            <vs-button class="btnx" type="filled" color="primary" @click="seeBanner(slotProps.item.id)">
              {{ $t('Ver') }}
            </vs-button>
            <vs-dropdown vs-trigger-click>
              <vs-button class="btn-drop" type="filled" icon="expand_more"></vs-button>
              <vs-dropdown-menu>
                <ul style="min-width: 12rem">
                  <li>
                    <span
                      @click="editBanner(slotProps.item.id)"
                      class="cursor-pointer py-3 px-4 block text-primary hover:bg-primary hover:text-white w-full"
                    >
                      <feather-icon icon="EditIcon" svgClasses="w-4 h-4" />
                      <span class="ml-2">{{ $t('Editar') }}</span>
                    </span>
                  </li>

                  <vs-divider class="m-1" />
                  <li>
                    <span @click="deleteModalBanner(slotProps.item.id, slotProps.item.url)" class="cursor-pointer py-3 px-4 block hover:bg-danger text-danger hover:text-white w-full" >
                      <feather-icon icon="TrashIcon" svgClasses="w-4 h-4" />
                      <span class="ml-2">{{ $t('Eliminar') }}</span>
                    </span>
                  </li>
                </ul>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </template>
        <template v-slot:active="slotProps" >
          <feather-icon
            icon="CheckCircleIcon"
            svgClasses="w-5 h-5 text-success hover:text-black stroke-current"
            @click="deactiveModalBanner(slotProps.item.id, slotProps.item.url)"
          />
        </template>
        <template v-slot:deactive="slotProps" >
          <feather-icon
            icon="XCircleIcon"
            svgClasses="w-5 h-5 text-danger hover:text-black stroke-current"
            @click="activeModalBanner(slotProps.item.id, slotProps.item.url)"
          />
        </template>
        <template v-slot:name="slotProps" >
          <a
            target="_blank"
            :href="$router.resolve().href"
            class="disabled hover:text-black" :disabled="isItemActive(slotProps.item.active) ? '' : disabled"
          >
            {{ slotProps.item.name }}
            </a>
        </template>
      </table-data-grid>
      <vs-popup :title="$t('banner.EditBanner')" class="popup-w-900" v-if="openModal()" :active.sync="popupEditBanner">
        <edit-banner
          :isGeneric="isGeneric"
          :banner="itemBanner"
          v-if="openModal()"
        />
      </vs-popup>
      <vs-popup :title="$t('banner.SeeBanner')" v-if="openModalSee()" :active.sync="popupSeeBanner">
        <see-banner
          :banner="itemBanner"
          v-if="openModalSee()"
          />
      </vs-popup>
    </div>
  </div>
</div>
</template>
<script>
    import TableDataGrid from '../components/TableDataGrid';
    import SeeBanner from '../components/Banners/SeeBanner.vue';
    import NewBanner from '../components/Banners/NewBanner.vue';
    import EditBanner from '../components/Banners/EditBanner.vue';
    import { mapActions, mapMutations, mapGetters } from 'vuex';

    export default {
      components: {
          TableDataGrid,
          NewBanner,
          EditBanner,
          SeeBanner
      },
      data () {
        return {
          isGeneric: true,
          dataColumns: [
            {dataField: 'id', caption: 'ID', visible: false},
            {caption: this.$t('Imagen'), dataType: 'image', visible: true, width: 170},
            {dataField: 'active', caption: this.$t('Activo'), dataType: 'slot', visible: true, width: 75},
            {dataField: 'url', caption: this.$t('URL'), dataType: 'text', visible: true, width: 200 },
            {caption: 'Slug', dataType: 'text', visible: false}
          ],
        }
      },
      created () {
        this.refreshBanners();
      },
      computed: {
        ...mapGetters({
          banners: 'getItemsBanners',
          itemBanner: 'getBanner',
          createdCorrect: 'getCreatedCorrect'
        }),
        popupSeeBanner: {
            get ()    { return this.$store.getters.getpopupSeeBanner },
            set (val) { this.$store.commit('setpopupSeeBanner', val) }
        },
        popupNewBanner: {
          set (val) {
            this.$store.commit('setpopupNewBanner', val);
          },
          get() {
            return this.$store.getters.getpopupNewBanner;
          }
        },
        popupEditBanner: {
          get () { return this.$store.getters.getpopupEditBanner },
          set (val) {
            this.$store.commit('setpopupEditBanner', val)
          }
        },
        itemsDataGrid () {
          const items = this.banners;
          const results = [];
          const placeholder = process.env.VUE_APP_IMAGE_PLACEHOLDER;
          items.forEach(function (item, index) {
              results[index] = {
                  id: items[index].id,
                  path: `<img src="${  placeholder  }" style="width: 175px;" class="product-img" >`,
                  active: 'deactive',
                  url: item.url
              };
              if (items[index].path) {
                  results[index].path = `<img src="${  items[index].path  }" style="width: 175px;" class="product-img" >`;
              }
              if (items[index].active === 1) {
                  results[index].active = 'active';
              }

          }, items)
          return results
        }
      },
      methods: {
       ...mapMutations({
          setBanner: 'setItemBanner',
          loading: 'loading',
        }),
        ...mapActions({
          refreshBanners: 'refreshBanners',
          activeBanner: 'activeBanner',
          deactiveBanner: 'deactiveBanner',
          deleteBanner: 'deleteBanner',
          getBanner: 'getBanner'
        }),
        setpopupNewBanner (val) {
            this.popupNewBanner = val
            this.$refs.newGenBannerModal.resetForm();
        },
        deleteModalBanner (idBanner, url) {
            const aux = this;
            this.$vs.dialog({
                type:'confirm',
                color: 'danger',
                title: this.$t('banner.DeleteBanner'),
                text: this.$t('banner.DeleteConfirm', { nombre: url }),
                acceptText: this.$t('Aceptar'),
                cancelText: this.$t('Cancelar'),
                accept () {
                    aux.deleteBanner({ id: idBanner, restaurant_id: null })
                }
            })
        },
        isItemActive (active) {
          if (active === 'active') {
            return false;
          } else {
            return true;
          }
        },
        seeBanner(idBanner) {
          this.getBanner({id: idBanner});
          this.popupSeeBanner = true;
        },
        openModalSee () {
          if (this.popupSeeBanner === true && Object.keys(this.itemBanner).length > 0) {
              return true;
          }
          return false;
        },
        openModal () {
          if (this.popupEditBanner === true && Object.keys(this.itemBanner).length > 0) {
              return true;
          }
          return false;
        },
        editBanner (id) {
          this.setBanner({});
          this.getBanner({id});
          this.popupEditBanner = true;
        },
        activeModalBanner (idBanner, name) {
          const aux = this;
          this.$vs.dialog({
              type:'confirm',
              color: 'success',
              title: this.$t('banner.ActiveBanner'),
              text: this.$t('banner.ActiveConfirm', { nombre: name }),
              acceptText: this.$t('Aceptar'),
              cancelText: this.$t('Cancelar'),
              accept () {
                  aux.activeBanner({ id: idBanner, restaurant_id: null })
              }
          })
        },
        deactiveModalBanner (idBanner, url) {
          const aux = this;
          this.$vs.dialog({
              type:'confirm',
              color: 'danger',
              title: this.$t('banner.DeactiveBanner'),
              text: this.$t('banner.DeactiveConfirm', {nombre: url}),
              acceptText: this.$t('Aceptar'),
              cancelText: this.$t('Cancelar'),
              accept () {
                  aux.deactiveBanner({ id: idBanner, restaurant_id: null })
              }
          })
      }
      }
    }
</script>
<style>
</style>
